import { c as _c } from "react/compiler-runtime";
import { HOTEL_DETAILS_MODAL } from "@website/accommodation-ui/constant/keys";
import { TourCardCarousel } from "@website/accommodation-ui/tour-card/tour-card-carousel";
import { TourCardGeneralTags } from "@website/accommodation-ui/tour-card/tour-card-general-tags/tour-card-general-tags";
import { TourCardHotel } from "@website/accommodation-ui/tour-card/tour-card-hotel";
import { TourCardHotelFurthermore } from "@website/accommodation-ui/tour-card/tour-card-hotel/tour-card-hotel-furthermore";
import { HotelThumbnailsType } from "@website/accommodation-ui/tour-card/tour-card-hotel/types";
import { TourCardPrice } from "@website/accommodation-ui/tour-card/tour-card-price";
import { Index } from "@website/accommodation-ui/tour-card/tour-card-snapp-pay-badge";
import { TourCardPropertiesType } from "@website/accommodation-ui/tour-card/types";
import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { getImage } from "@website/utils/get-image";
import { useRouter } from "next/router";
import { FC } from "react";
export const TourCard: FC<TourCardPropertiesType> = properties => {
  const $ = _c(53);
  const {
    hotel,
    badges,
    installmentWallet,
    pricing,
    departureFlight: t0
  } = properties;
  const {
    transportType
  } = t0;
  const {
    id
  } = hotel;
  const {
    isMobile
  } = useViewPort();
  const router = useRouter();
  let t1;
  if ($[0] !== hotel.thumbnails) {
    t1 = hotel.thumbnails?.map(_temp) || [];
    $[0] = hotel.thumbnails;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const thumbnails = t1;
  let t2;
  if ($[2] !== badges) {
    t2 = badges || [];
    $[2] = badges;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = t2.filter(_temp2);
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const regularBadges = t3;
  let t4;
  if ($[6] !== badges) {
    t4 = badges || [];
    $[6] = badges;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = t4.filter(_temp3);
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const partnerShipBadges = t5;
  const isFlight = transportType === "FLIGHT";
  const transportationTypeText = isFlight ? "\u067E\u0631\u0648\u0627\u0632" : "\u0642\u0637\u0627\u0631";
  const t6 = `shadow-1 bg-background flex justify-between overflow-hidden rounded-xl max-md:flex-col ${router.query[HOTEL_DETAILS_MODAL] === hotel.id.toString() ? "border-secondary border-2" : ""}`;
  let t7;
  if ($[10] !== hotel.id || $[11] !== hotel.stars || $[12] !== hotel.thumbnails || $[13] !== partnerShipBadges || $[14] !== thumbnails) {
    t7 = hotel?.thumbnails && <TourCardCarousel badges={partnerShipBadges} id={hotel.id.toString()} stars={hotel.stars} thumbnails={thumbnails} />;
    $[10] = hotel.id;
    $[11] = hotel.stars;
    $[12] = hotel.thumbnails;
    $[13] = partnerShipBadges;
    $[14] = thumbnails;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== properties) {
    t8 = <TourCardHotel {...properties} />;
    $[16] = properties;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = `text-xl ${isFlight ? "rotate-45" : ""}`;
  const t10 = isFlight ? "flight" : "train";
  let t11;
  if ($[18] !== t10 || $[19] !== t9) {
    t11 = <MaterialIcon className={t9} name={t10} />;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== transportationTypeText) {
    t12 = <div className="text-on-surface-high-emphasis text-sm">شامل {transportationTypeText} رفت و برگشت</div>;
    $[21] = transportationTypeText;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t11 || $[24] !== t12) {
    t13 = <div className="mb-2 flex items-center gap-1 px-4 py-1 md:mb-3">{t11}{t12}</div>;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== regularBadges) {
    t14 = <div className="mb-3 px-4"><TourCardGeneralTags tags={regularBadges} /></div>;
    $[26] = regularBadges;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== installmentWallet?.isEligible || $[29] !== isMobile || $[30] !== pricing) {
    t15 = Boolean(!isMobile && installmentWallet?.isEligible) && <Index pricing={pricing} />;
    $[28] = installmentWallet?.isEligible;
    $[29] = isMobile;
    $[30] = pricing;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== id || $[33] !== properties) {
    t16 = Boolean(id) && <TourCardHotelFurthermore {...properties} />;
    $[32] = id;
    $[33] = properties;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t13 || $[36] !== t14 || $[37] !== t15 || $[38] !== t16 || $[39] !== t8) {
    t17 = <div className="mb-1 flex flex-1 flex-col flex-wrap">{t8}{t13}{t14}{t15}{t16}</div>;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
    $[39] = t8;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== properties) {
    t18 = <div className="border-r-outline-thin items-center border-r md:flex"><TourCardPrice showPersonNumbers={true} source="ResultSearchPage" {...properties} /></div>;
    $[41] = properties;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== installmentWallet?.isEligible || $[44] !== isMobile || $[45] !== pricing) {
    t19 = Boolean(isMobile && installmentWallet?.isEligible) && <Index pricing={pricing} />;
    $[43] = installmentWallet?.isEligible;
    $[44] = isMobile;
    $[45] = pricing;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t17 || $[48] !== t18 || $[49] !== t19 || $[50] !== t6 || $[51] !== t7) {
    t20 = <div><div className={t6}>{t7}{t17}{t18}{t19}</div></div>;
    $[47] = t17;
    $[48] = t18;
    $[49] = t19;
    $[50] = t6;
    $[51] = t7;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  return t20;
};
function _temp(thumbnail) {
  return {
    src: getImage({
      src: thumbnail.src,
      width: 500,
      height: 500
    }),
    title: thumbnail.title
  } as HotelThumbnailsType;
}
function _temp2(b) {
  return b.type?.toLowerCase() !== "partnership";
}
function _temp3(b_0) {
  return b_0.type?.toLowerCase() === "partnership";
}